import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { PropsWithChildren } from 'react';
import { ExclamationIcon } from '../../icons';
import { Spacer } from '../layout';

interface EmptyStateProps extends BoxProps {
  title: string;
  subtitle: string | React.ReactNode;
  icon?: React.ReactNode;
}

const EmptyState: React.FC<PropsWithChildren<EmptyStateProps>> = ({
  title,
  subtitle,
  icon,
  children,
  ...props
}) => (
  <Box
    {...props}
    sx={[
      {
        minHeight: '250px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: '8px',
        padding: '16px',
        gap: 2,
        textAlign: 'center',
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  >
    <Spacer height="1.5rem" />
    {icon ?? <ExclamationIcon height={30} width={30} />}
    <Typography variant="h4" sx={{ marginTop: '8px' }}>
      {title}
    </Typography>
    <Typography variant="subtitle1" component={'div'} sx={{ marginTop: '8px' }}>
      {subtitle}
    </Typography>
    {children}
  </Box>
);

export default EmptyState;
